import React from 'react'

function NotificationIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 16 16"><path fill="currentColor" d="M8 1.5c-1.736 0-3.369.676-4.596 1.904S1.5 6.264 1.5 8s.676 3.369 1.904 4.596S6.264 14.5 8 14.5s3.369-.676 4.596-1.904S14.5 9.736 14.5 8s-.676-3.369-1.904-4.596S9.736 1.5 8 1.5M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M7 11h2v2H7zm0-8h2v6H7z"/></svg>
  )
}

export default NotificationIcon